import { render, staticRenderFns } from "./MenuCategories.vue?vue&type=template&id=632f3b16&"
import script from "./MenuCategories.vue?vue&type=script&lang=js&"
export * from "./MenuCategories.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports